import React from "react";
import { Container, Table } from "reactstrap";
import moment from "moment";
import "./multipleClientsTable.css";
const MultipleClientsTable = ({ multipleClientsReport }) => {

  return (
    <Container>
      <Table className="multiple-clients-result-table">
        <tbody>
          <tr>
            <td className="multiple-clients-result-label">
              {multipleClientsReport.tenantNameLabel}
            </td>
            <td className="multiple-clients-result-value">
              {multipleClientsReport.tenantName}
            </td>
          </tr>
          <tr>
            <td className="multiple-clients-result-label">
              {multipleClientsReport.dateOfReportGenerationLabel}
            </td>
            <td className="multiple-clients-result-value">
              {moment
                .utc(multipleClientsReport.dateOfReportGeneration)
                .local()
                .format("DD.MM.YYYY HH:mm:ss")}
            </td>
          </tr>
          <tr>
            <td className="multiple-clients-result-label">
              {multipleClientsReport.numberOfClientsInTheReportLabel}
            </td>
            <td className="multiple-clients-result-value">
              {multipleClientsReport.numberOfClients}
            </td>
          </tr>
          <tr>
            <td className="multiple-clients-result-label">
              {multipleClientsReport.createdByLabel}
            </td>
            <td className="multiple-clients-result-value">
              {multipleClientsReport.createdBy}
            </td>
          </tr>
        </tbody>
      </Table>
      {/* {clientReports} */}
    </Container>
  );
};

export default MultipleClientsTable;



// WEBPACK FOOTER //
// ./src/features/reports/pages/multiple-clients-report/multiple-clients-table/MultipleClientsTable.jsx